<div *ngIf="report?.result">
  <div [innerHtml]="report?.resultMessage"></div>
</div>
<div *ngIf="!report?.result">{{'Global.ReportNotFound' | translate }}</div>
